(() => {
  const productFormSelector = 'form[data-product-form]';
  const checkingAttribute = 'data-dopamina-cart-checking';
  const bypassAttribute = 'data-dopamina-cart-bypass';

  const cartUrl = () => `${window.Shopify?.routes?.root || '/'}cart.js`;

  const getCart = () => fetch(cartUrl(), {
    credentials: 'same-origin',
    headers: { Accept: 'application/json' }
  }).then((response) => {
    if (!response.ok) throw new Error('Cart unavailable');
    return response.json();
  });

  const getVariantId = (form) => String(new FormData(form).get('id') || '');

  const itemIsInCart = (cart, variantId) => cart.items.some((item) => (
    String(item.variant_id) === variantId && item.quantity > 0
  ));

  const getButton = (form) => form.querySelector('[type="submit"].add-to-cart');

  const setButtonLabel = (button, inCart) => {
    if (!button) return;

    const noJsLabel = button.querySelector('.no-js');
    if (!button.dataset.dopaminaAddLabel && noJsLabel) {
      button.dataset.dopaminaAddLabel = noJsLabel.textContent.trim();
    }

    const language = document.documentElement.lang.toLowerCase();
    const label = inCart
      ? (language.startsWith('en') ? 'View cart \u2192' : 'Ver carrito \u2192')
      : button.dataset.dopaminaAddLabel;

    if (!label) return;

    button.querySelectorAll('span').forEach((span) => {
      if (!span.querySelector('span')) span.textContent = label;
    });
    button.dataset.dopaminaItemInCart = inCart ? 'true' : 'false';
    button.setAttribute('aria-label', label);
  };

  const openCart = (button) => {
    if (window.Spruce?.store) {
      const drawer = window.Spruce.store('drawer');
      drawer.cartOpener = button;
      document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem'));
      drawer.cartDrawerOpen = true;
      return;
    }

    window.location.assign(window.theme?.routes?.cart_url || '/cart');
  };

  const refreshProductForms = () => {
    const forms = Array.from(document.querySelectorAll(productFormSelector));
    if (!forms.length) return;

    getCart().then((cart) => {
      forms.forEach((form) => {
        setButtonLabel(getButton(form), itemIsInCart(cart, getVariantId(form)));
      });
    }).catch(() => {});
  };

  document.addEventListener('submit', (event) => {
    const form = event.target.closest(productFormSelector);
    if (!form) return;

    if (form.getAttribute(bypassAttribute) === 'true') {
      form.removeAttribute(bypassAttribute);
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    if (form.getAttribute(checkingAttribute) === 'true') return;
    form.setAttribute(checkingAttribute, 'true');

    const button = getButton(form);
    if (button) button.disabled = true;

    getCart().then((cart) => {
      const inCart = itemIsInCart(cart, getVariantId(form));
      setButtonLabel(button, inCart);

      if (inCart) {
        if (button) button.disabled = false;
        openCart(button);
        return;
      }

      form.setAttribute(bypassAttribute, 'true');
      if (button) button.disabled = false;
      form.requestSubmit(button || undefined);
    }).catch(() => {
      form.setAttribute(bypassAttribute, 'true');
      if (button) button.disabled = false;
      form.requestSubmit(button || undefined);
    }).finally(() => {
      form.removeAttribute(checkingAttribute);
    });
  }, true);

  document.addEventListener('DOMContentLoaded', refreshProductForms);
  window.addEventListener('pageshow', refreshProductForms);
  document.body.addEventListener('baseline:modalcart:itemcountupdate', (event) => {
    if (event.detail?.count === 0) {
      document.querySelectorAll(productFormSelector).forEach((form) => {
        setButtonLabel(getButton(form), false);
      });
    }

    window.setTimeout(refreshProductForms, 300);
  });
})();
